import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  layoutWrapper: theme => css`
    .negative-appointment-validation {
      color: ${theme.colors.danger[500]} !important;

      &:hover {
        color: ${theme.colors.danger[700]} !important;
      }
    }
    .negative-reservation-cancelled {
      color: ${theme.colors.primary[500]} !important;

      &:hover {
        color: ${theme.colors.primary[700]} !important;
      }
    }
  `,
  confirmWrapper: () => css`
    h2 {
      margin-bottom: 8px;
    }
  `,
  containerText: () => css`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 24px;
  `,
  reservationCancelledWrapper: () => css`
    padding: 0.6rem;
    display: flex;
    flex-direction: column;
  `,
  reservationCancelledIllustration: () => css`
    display: flex;
    justify-content: center;
    padding: 1rem;
  `,
  reservationCancelledContainerText: () => css`
    padding: 0.6rem;
    text-align: center;
    p {
      padding: 1rem;
      margin-bottom: 1rem;
    }
  `,
})

export default useStyles
